const globalStyleIdTextNumber = 'gs-text-number';
const globalStyleIdTextLabel = 'gs-text-label';
const defaultSelectorTextNumber = {
  selector: '#{mID} .module .num',
};
const defaultSelectorTextLabel = {
  selector: '#{mID} .module .count-label',
};
export default {
  defaultClass: 'gf_gs-text-paragraph-1',
  settingGroups: {
    [globalStyleIdTextNumber]: {
      // "number-color": {
      //   ...defaultSelectorTextNumber,
      //   inherit: "text.fontColor",
      //   cssAttr: "color"
      // },
      'number-font': {
        ...defaultSelectorTextNumber,
        inherit: 'text.fontFamily',
        cssAttr: 'font-family',
      },
      'number-size': {
        ...defaultSelectorTextNumber,
        inherit: 'text.fontSize',
        cssAttr: 'font-size',
        listUnit: 'px',
      },
    },
    [globalStyleIdTextLabel]: {
      // "text-color": {
      //   ...defaultSelectorTextLabel,
      //   inherit: "text.fontColor",
      //   cssAttr: "color"
      // },
      'text-font': {
        ...defaultSelectorTextLabel,
        inherit: 'text.fontFamily',
        cssAttr: 'font-family',
      },
      'text-size': {
        ...defaultSelectorTextLabel,
        inherit: 'text.fontSize',
        cssAttr: 'font-size',
        listUnit: 'px',
      },
    },
  },
};

export const COUNTDOWN_SETTING = [
  {
    gsId: globalStyleIdTextNumber,
    gsSettingGroup: 'Text Number',
    isRenderColumn: false,
    prefix: 'gf_gs-text-',
    typeSetting: 'heading-paragraph',
  },
  {
    gsId: globalStyleIdTextLabel,
    gsSettingGroup: 'Text Label',
    isRenderColumn: false,
    prefix: 'gf_gs-text-',
    typeSetting: 'heading-paragraph',
  },
];
